import React, { useRef } from "react";
import { TiLocation } from "react-icons/ti";
import { Popover } from "antd";

// components
import SearchMapMarkContent from "./components/SearchMapMarkContent";

// helpers
import useUserProfile from "@/hooks/useUserProfile";

// interfaces
import { ISearchMapMark } from "./ISearchMapMark";

// assets
import styles from "@/assets/styles/components/search-map-mark.module.scss";

const SearchMapMark = ({
  location,
  activeLocationId,
  setIsHovered,
}: ISearchMapMark) => {
  const { isAuthorized } = useUserProfile();

  const { id } = location;

  const isActive = id === activeLocationId;
  const accessRestricted = location.accessRestricted && !isAuthorized;

  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div
      className={styles["locl-search-map-mark"]}
      ref={containerRef}
      data-testid="locl-search-map-mark"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isActive && <div className={styles["locl-search-map-mark__pulse"]}/>}
      <Popover
        overlayClassName={styles["locl-search-map-mark-popover"]}
        getPopupContainer={() => containerRef.current as HTMLDivElement}
        content={
          <SearchMapMarkContent
            accessRestricted={accessRestricted}
            location={location}
          />
        }
      >
        <span className={styles["locl-search-map-mark__icon"]}>
          <TiLocation/>
        </span>
      </Popover>
    </div>
  );
};

export default SearchMapMark;
